// Keep the hero reveal independent of slow video downloads; posters cover first paint.
const HERO_REVEAL_DELAY_MS = 100;

function initWipeReveal() {
  const wipes = document.querySelectorAll(".wipe");
  if (!wipes.length) {
    return;
  }

  const reveal = (wipe) => {
    wipe.classList.add("wipe--revealed");
  };

  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    wipes.forEach((w) => reveal(w));
    return;
  }

  if (typeof IntersectionObserver === "undefined") {
    wipes.forEach((w) => reveal(w));
    return;
  }

  const heroWipe = document.querySelector(".hero .wipe");
  const otherWipes = Array.from(wipes).filter((w) => w !== heroWipe);

  if (heroWipe) {
    window.setTimeout(() => {
      reveal(heroWipe);
    }, HERO_REVEAL_DELAY_MS);
  }

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
          reveal(entry.target);
          observer.unobserve(entry.target);
        }
      }
    },
    {
      root: null,
      rootMargin: "0px 0px -12% 0px",
      threshold: [0.5],
    },
  );

  for (const wipe of otherWipes) {
    observer.observe(wipe);
  }
}

document.addEventListener("DOMContentLoaded", initWipeReveal);
